<section
    class="flex items-center justify-between gap-[8px] px-[10px] py-[7px] rounded-[6px] border-1 dropshadow-sm border-border-inverted"
    [ngClass]="{
        'bg-background text-foreground fill-foreground': type() === 'light',
        'bg-secondary text-secondary-foreground fill-secondary-foreground': type() === 'secondary',
        '!border-border-solid': type() === 'secondary' || type() === 'light',
        'bg-success-fade text-success-foreground fill-success-foreground' : type() === 'success',
        'bg-danger-fade text-danger-foreground fill-danger-foreground' : type() === 'danger',
        'bg-warning-fade text-warning-foreground fill-warning-foreground' : type() === 'warning',
        'bg-blue-fade text-blue-foreground fill-blue-foreground' : type() === 'info',
        'bg-purple-fade text-purple-foreground fill-purple-foreground' : type() === 'purple',
        'bg-pink-fade text-pink-foreground fill-pink-foreground' : type() === 'pink',
        'bg-orange-fade text-orange-foreground fill-orange-foreground' : type() === 'orange',
        'bg-lime-fade text-lime-foreground fill-lime-foreground' : type() === 'lime',
        'bg-emerald-fade text-emerald-foreground fill-emerald-foreground' : type() === 'emerald',
        'bg-cyan-fade text-cyan-foreground fill-cyan-foreground' : type() === 'cyan',
    }">
    @if (icon() || systemIcon()) {
    <div class="w-[20px] min-w-[20px] h-[20px] flex items-center justify-center" [ngClass]="{'mb-auto': title() && text() }">
        @if (icon()) {
        <i class="fi fi-rr-{{icon()}} !leading-[16px] !text-[16px] !h-[16px] block my-[4px] mx-[2px]"></i>
        }
        @if (systemIcon()) {
        <lib-system-icons [iconName]="systemIcon()"></lib-system-icons>
        }
    </div>
    }
    
    @if (title() || text()) {
    <div class="mr-auto">
        @if (title()) {
        <h3 class="content-semibold leading-[24px]">{{title() | translate }}</h3>
        }
        @if (text()) {
        <p [ngClass]="{
            '!text-foreground-75': type() === 'light',
            'content-regular leading-[24px]': !title(),
            'content-sm-regular leading-[20px]': title(),
        }">
            {{text() | translate}}
            @if (link()) {
            <a [href]="link().url" target="_blank" rel="noopener noreferrer" class="text-link underline">
                {{link().text| translate}}
            </a>
            }
        </p>
        }
    </div>
    }
    @if (iconButton()) {
    <lib-icon-button type="ghost" [icon]="iconButton()" (click)="buttonClicked.emit()"></lib-icon-button>
    }
</section>